function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useContext, useEffect, useState } from "react";
import StoreContext from "@/context/root-store";
import { observer } from "mobx-react";
import TiTroviIn from "@/widget/TiTroviIn";
import Allegato1 from "../../../resources/AVVISOODC14FEBBRAIO2023.pdf";
import Allegato2 from "../../../resources/Allegato1Domanda14febbraio2023.pdf";
import Allegato3 from "../../../resources/Allegato1bisInformativa14febbraio2023.pdf";
import Allegato4 from "../../../resources/Allegato2Dichiarazione14febbraio2023.pdf";
// @ts-ignore
import LogoParita from "../../../img/logoheaderpage.png";
import "../../../../css/Faq.css";
var listaBandiEAvvisi = [{
  "title": "Avviso pubblico per la concessione di contributi alle micro, piccole e medie imprese per servizi di assistenza tecnica e accompagnamento in forma di voucher e per servizi di certificazione della Parità di Genere UNI/PdR 125:2022 - PNRR, Missione 5, Componente 1, Investimento 1.3 (“Sistema di certificazione della parità di genere”)",
  "text6": /*#__PURE__*/React.createElement("a", {
    href: "https://certificazioneparitadigenere.unioncamere.gov.it/",
    target: "_blank"
  }, "Fai domanda"),
  "category": 1
}, {
  "title": "Avviso pubblico per la formazione di un elenco di organismi di certificazione accreditati interessati ad aderire alle misure di agevolazione delle PMI per i costi di certificazione della parità di genere",
  "text": /*#__PURE__*/React.createElement("a", {
    href: Allegato1,
    target: "_blank"
  }, "Avviso"),
  "text2": /*#__PURE__*/React.createElement("a", {
    href: Allegato2,
    target: "_blank"
  }, "Allegato 1"),
  "text3": /*#__PURE__*/React.createElement("a", {
    href: Allegato3,
    target: "_blank"
  }, "Allegato 1 bis"),
  "text4": /*#__PURE__*/React.createElement("a", {
    href: Allegato4,
    target: "_blank"
  }, "Allegato 2"),
  "text5": /*#__PURE__*/React.createElement("a", {
    href: "https://certificazione.pariopportunita.gov.it/public/organismi-di-certificazione",
    target: "_blank"
  }, "Elenco Organismi di certificazione"),
  "category": 1
}

// {
//   "title": "UNAR- Avviso pubblico per la selezione ed il finanziamento di progetti finalizzati alla realizzazione di campagne di comunicazione volte a sensibilizzare e informare la cittadinanza sui diritti delle persone LGBTIQ",
//   "text": "...",
//   "category": 1
// },
// {
//   "title": "Avviso pubblico per il finanziamento di iniziative di informazione e sensibilizzazione rivolti alla prevenzione della violenza maschile contro le donne",
//   "text": "...",
//   "category": 1
// },
// {
//   "title": "Bando di gara - Affidamento del servizio di analisi, ricerche e sviluppo metodologico pr l'integrazione della prospettiva di genere nell'ambito della programmazione comunitaria per l'attuazione del progetto “Metodi e strumenti valutativi per il mainstreaming di genere”",
//   "text": "...",
//   "category": 1
// }
];
var BandiAvvisi = observer(function (props) {
  var rootStore = useContext(StoreContext).rootStore;
  var _useState = useState(listaBandiEAvvisi),
    _useState2 = _slicedToArray(_useState, 2),
    bandiAvvisiInitial = _useState2[0],
    setBandiAvvisiInitial = _useState2[1];
  var _useState3 = useState(bandiAvvisiInitial),
    _useState4 = _slicedToArray(_useState3, 2),
    bandiAvvisiList = _useState4[0],
    setBandiAvvisiList = _useState4[1];
  var BREADCRUMB_TITOLO = "Contributi";
  var BREADCRUMB_CHILDREN = [{
    to: process.env.CONTEXT_PATH + "/home",
    label: "Home"
  }];
  var breadcrumb = /*#__PURE__*/React.createElement(TiTroviIn, {
    children: BREADCRUMB_CHILDREN,
    title: BREADCRUMB_TITOLO
  });
  var $ = require("jquery");
  useEffect(function () {
    document.title = "Certificazione della parità di genere - Contributi";
    $("#ita.list-inline-item").addClass("active");
    $("#eng.list-inline-item").removeClass("active");
  });
  var searchBandiAvvisi = function searchBandiAvvisi(event) {
    var value = event.target.value;
    var newBandiAvvisi = bandiAvvisiInitial.filter(function (bea) {
      return bea.title.toLowerCase().includes(value.toLowerCase());
    });
    setBandiAvvisiList(newBandiAvvisi);
  };
  return rootStore.uiStore.numberCallback === 0 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "bgColorGrayLight"
  }, /*#__PURE__*/React.createElement("div", {
    className: "postizioneLogoHeader"
  }, /*#__PURE__*/React.createElement("img", {
    src: LogoParita,
    alt: "Logo parit\xE0 di genere",
    className: "img-fluid dimImage",
    width: "500"
  })), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-0"
  }, breadcrumb, /*#__PURE__*/React.createElement("div", {
    className: "row altezzaMin"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("h2", null, "Contributi"), /*#__PURE__*/React.createElement("p", null, "Nella presente sezione \xE8 pubblicato ", /*#__PURE__*/React.createElement("b", null, "l\u2019Avviso per l\u2019erogazione dei contributi alle PMI"), " per i servizi di assistenza tecnica e accompagnamento alla certificazione della parit\xE0 di genere e dei contributi per i costi di certificazione. Questi ultimi saranno pagati direttamente agli OdC che hanno aderito all\u2019", /*#__PURE__*/React.createElement("b", null, "Avviso per la formazione di un elenco degli organismi di certificazione accreditati"), " per lo schema di certificazione della parit\xE0 di genere UNI/PdR 125:2022, interessati a aderire alla misura di agevolazione delle piccole e medie imprese e microimprese (PMI), anch\u2019esso qui pubblicato."), "            ")))), /*#__PURE__*/React.createElement("div", {
    className: "container-fluid py-3 py-md-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-10 margini"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-lg-6 offset-lg-6 col-sm-12"
  }, /*#__PURE__*/React.createElement("form", {
    name: "",
    action: "",
    className: ""
  }, /*#__PURE__*/React.createElement("div", {
    className: "form-group"
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: "...",
    className: "sr-only"
  }, "Cerca:"), /*#__PURE__*/React.createElement("div", {
    className: "input-group"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    id: "...",
    name: "...",
    className: "form-control",
    placeholder: "Cerca...",
    onChange: searchBandiAvvisi
  }), /*#__PURE__*/React.createElement("div", {
    className: "input-group-append"
  }, /*#__PURE__*/React.createElement("button", {
    type: "submit",
    className: "btn btn-primary"
  }, /*#__PURE__*/React.createElement("i", {
    className: "fas fa-search"
  }), /*#__PURE__*/React.createElement("span", {
    className: "sr-only"
  }, "Cerca"))))))), /*#__PURE__*/React.createElement("div", {
    "data-bs-spy": "scroll",
    "data-bs-target": "#list-example",
    "data-bs-smooth-scroll": "true",
    className: "scrollspy-example"
  }, /*#__PURE__*/React.createElement("div", null, bandiAvvisiList && bandiAvvisiList.map(function (bea, index) {
    return /*#__PURE__*/React.createElement("div", {
      className: "card card-default card-collapsible-reverse"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-header"
    }, /*#__PURE__*/React.createElement("h3", {
      className: "card-title d-flex align-items-center justify-content-between"
    }, /*#__PURE__*/React.createElement("a", {
      href: "#collapse-reverse-".concat(index),
      className: "d-flex justify-content-between align-items-center collapsed custom-collapse-title text-decoration-none",
      "data-toggle": "collapse",
      "aria-expanded": "false",
      "aria-controls": "collapse-reverse-".concat(index)
    }, bea.title), /*#__PURE__*/React.createElement("i", {
      className: "fas fa-chevron-down custom-collapse-title"
    }))), /*#__PURE__*/React.createElement("div", {
      id: "collapse-reverse-".concat(index),
      className: "collapse"
    }, /*#__PURE__*/React.createElement("div", {
      className: "card-body"
    }, /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text6), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text7), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text8), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text9), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text10), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text11), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text12), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text2), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text3), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text4), /*#__PURE__*/React.createElement("p", {
      className: "custom-collapse-text"
    }, bea.text5))));
  })))))));
});
export default BandiAvvisi;